import axios from "axios";

import { farmageo_api } from "../../config";
import {
  requestErrorHandler,
  alertarMensaje,
} from "./context/FuncionesContext";
import { configuracionesRef, addsql } from "./context/PantallaReducer";
import { agregarAcciones, tryFocusWithRetry } from "./helper/funciones";
import {
  excluirConfiguracionesCss,
  obtenerCssDeConfiguraciones,
} from "./helper/configuracionesCss";

export const CONFIRMAR_CERRAR_PANTALLA_ATTR = "confirmar_cerrar_pantalla";
export const CONFIRMAR_CERRAR_PANTALLA_MENSAJE_ATTR =
  "confirmar_cerrar_pantalla_mensaje";
export const OMITIR_CONFIRMAR_CERRAR_PANTALLA_KEY =
  "__omitir_confirmar_cerrar_pantalla__";
export const CANCELAR_NAVEGACION_PANTALLA_KEY =
  "__cancelar_navegacion_pantalla__";

export const makeBody = (search) => {
  const qs = search?.split("?")[1];
  if (!qs) return {};

  const qsPairs = qs.split("&");
  const resBody = {};

  qsPairs.forEach((q) => {
    const kp = q.split("=");
    if (!kp[0]) return;
    resBody[kp[0]] = kp[1];
  });

  return resBody;
};

export const resolveLocationStateFromReferrer = (locationState = {}) => {
  const nextLocationState = {
    filtros: {},
    ...locationState,
  };
  const ref = localStorage.getItem("referrer");
  const ses = sessionStorage.getItem("referrer");
  const referrer = ref ? JSON.parse(ref) : undefined;
  const session = ses ? JSON.parse(ses) : undefined;

  if (referrer) {
    localStorage.removeItem("referrer");
    sessionStorage.setItem("referrer", JSON.stringify(referrer));

    if (referrer.filtros) {
      nextLocationState.filtros = referrer.filtros;
    }
  }

  if (session?.filtros) {
    nextLocationState.filtros = session.filtros;
  }

  return nextLocationState;
};

export const habilitarSalidaSinConfirmacion = () => {
  sessionStorage.setItem(OMITIR_CONFIRMAR_CERRAR_PANTALLA_KEY, "s");
};

export const consumirSalidaSinConfirmacion = () => {
  const enabled =
    sessionStorage.getItem(OMITIR_CONFIRMAR_CERRAR_PANTALLA_KEY) === "s";

  if (enabled) {
    sessionStorage.removeItem(OMITIR_CONFIRMAR_CERRAR_PANTALLA_KEY);
  }

  return enabled;
};

export const limpiarCancelacionNavegacionPantalla = () => {
  sessionStorage.removeItem(CANCELAR_NAVEGACION_PANTALLA_KEY);
};

export const marcarCancelacionNavegacionPantalla = () => {
  sessionStorage.setItem(CANCELAR_NAVEGACION_PANTALLA_KEY, "s");
};

export const consumirCancelacionNavegacionPantalla = () => {
  const cancelled =
    sessionStorage.getItem(CANCELAR_NAVEGACION_PANTALLA_KEY) === "s";

  if (cancelled) {
    sessionStorage.removeItem(CANCELAR_NAVEGACION_PANTALLA_KEY);
  }

  return cancelled;
};

export const setPantalla = ({
  response,
  pantalla,
  id,
  setData,
  setRefState,
  setLoadingPantalla,
  setPantallaCss,
  opcionesPantalla,
}) => {
  if (pantalla.split("?")[0] !== response.data.opciones.id_a) {
    window.history.replaceState(
      {},
      "",
      "#/pantalla/" + response.data.opciones.id_a,
    );
  }

  const opciones_de_pantalla = { ...response.data.opciones };
  opcionesPantalla.current = opciones_de_pantalla;
  const configuraciones = response.data.configuraciones ?? [];
  const configuracionesRender = excluirConfiguracionesCss(configuraciones).map(
    (configuracion, index) => {
      if (index !== 0 || !configuracion?.opciones) return configuracion;

      return {
        ...configuracion,
        opciones: {
          ...configuracion.opciones,
          orden: 1,
        },
      };
    },
  );

  const pantallaData = {
    ...response.data,
    configuraciones: configuracionesRender,
  };

  setPantallaCss(obtenerCssDeConfiguraciones(configuraciones));

  agregarAcciones(
    opciones_de_pantalla,
    pantallaData.configuraciones[0]?.opciones,
  );

  const {
    configuraciones_ref,
    configuraciones_ida,
    configuraciones_ids,
    configuraciones_tipo,
    configuraciones_padre,
    configuraciones_cab,
    configuracionesDatos,
    notificaciones,
  } = configuracionesRef(pantallaData);

  setData(configuracionesDatos);

  setRefState({
    configuraciones: pantallaData.configuraciones,
    configuraciones_ref,
    configuraciones_ida,
    configuraciones_ids,
    configuraciones_tipo,
    configuraciones_padre,
    configuraciones_cab,
    sql: response.data.sql,
    pantalla_id: id,
    pantalla,
    opciones_de_pantalla,
    notificaciones,
  });

  setLoadingPantalla(false);
  document.dispatchEvent(new Event("pantallaLoaded"));
  return response;
};

export const createSetPantalla =
  ({
    pantalla,
    id,
    setData,
    setRefState,
    setLoadingPantalla,
    setPantallaCss,
    opcionesPantalla,
  }) =>
  (response) =>
    setPantalla({
      response,
      pantalla,
      id,
      setData,
      setRefState,
      setLoadingPantalla,
      setPantallaCss,
      opcionesPantalla,
    });

export const cargarPantalla = ({
  locationState,
  pantalla,
  qsBody,
  cancelSource,
  history,
  setRefState,
  id,
  onSetPantalla,
}) =>
  axios
    .post(farmageo_api + "/pantalla/" + pantalla, qsBody, {
      params: locationState?.filtros,
      cancelToken: cancelSource.current.token,
    })
    .then((response) => {
      const status = response.status || response.response?.status;

      if (status >= 400) {
        if (status === 404) {
          return history.replace("/404");
        }
        setRefState({
          sql: response.data.sql,
          pantalla_id: id,
          pantalla,
        });
        requestErrorHandler(response);
        return response;
      }

      if (response.data.message) {
        alertarMensaje(response.data.message);
      }

      return onSetPantalla(response);
    })
    .catch((err) => {
      console.log("cancel request...", err);
    });

export const createCargarPantalla =
  ({
    pantalla,
    qsBody,
    cancelSource,
    history,
    setRefState,
    id,
    onSetPantalla,
  }) =>
  (locationState) =>
    cargarPantalla({
      locationState,
      pantalla,
      qsBody,
      cancelSource,
      history,
      setRefState,
      id,
      onSetPantalla,
    });

export const createRefreshPantallaHandler =
  ({
    pantalla,
    qsBody,
    locationState,
    cancelSource,
    history,
    onSetPantalla,
    setLoadingPantalla,
    setRefState,
    refState,
  }) =>
  () => {
    console.log("refresh pantalla...");
    setLoadingPantalla(true);
    axios
      .post(farmageo_api + "/pantalla/" + pantalla, qsBody, {
        params: locationState?.filtros,
        cancelToken: cancelSource.current.token,
      })
      .then((response) => {
        const status = response.status || response.response.status;

        if (status >= 400) {
          if (status === 404) {
            return history.replace("/404");
          }
          requestErrorHandler(response);
          return response;
        }

        onSetPantalla(response);

        if (response.data.message) {
          alertarMensaje(response.data.message);
        }

        setLoadingPantalla(false);
        return response;
      })
      .catch((err) => {
        console.log("cancel request...", err);
      })
      .then((response) => {
        setRefState({ sql: addsql(response.data.sql, refState.sql) });
      })
      .catch((error) => {
        console.log(error);
      });
  };

export const createPantallaLoadedHandler =
  ({ defaultTitle, opcionesPantalla }) =>
  () => {
    document.title = opcionesPantalla.current?.title ?? defaultTitle.current;
    if (opcionesPantalla.current.focus_en) {
      tryFocusWithRetry(opcionesPantalla.current.focus_en);
    }
  };

export const createCargaPantallaEffect =
  ({
    setLoadingPantalla,
    setPantallaCss,
    cancelSource,
    cancelToken,
    onCargarPantalla,
    locationState,
  }) =>
  () => {
    setLoadingPantalla(true);
    setPantallaCss("");

    cancelSource.current = cancelToken.source();
    onCargarPantalla(locationState);

    return () => {
      cancelSource.current.cancel();
    };
  };

export const createRefreshPantallaEffect =
  ({ id_a, handleRefreshPantalla }) =>
  () => {
    document.addEventListener(id_a, handleRefreshPantalla);

    return () => {
      document.removeEventListener(id_a, handleRefreshPantalla);
    };
  };

export const createPantallaLoadedEffect =
  ({ handlePantallaLoaded }) =>
  () => {
    document.addEventListener("pantallaLoaded", handlePantallaLoaded);

    return () => {
      document.removeEventListener("pantallaLoaded", handlePantallaLoaded);
    };
  };

export const createPantallaCssEffect =
  ({ pantalla, pantallaCss }) =>
  () => {
    const styleId = `pantalla-css-${pantalla}`;
    const existingStyle = document.getElementById(styleId);

    if (!pantallaCss) {
      if (existingStyle) {
        existingStyle.remove();
      }
      return;
    }

    const style = existingStyle ?? document.createElement("style");
    style.id = styleId;
    style.dataset.component = "PantallaCss";
    style.dataset.pantalla = pantalla;
    style.textContent = pantallaCss;

    if (!existingStyle) {
      document.head.appendChild(style);
    }

    return () => {
      const styleNode = document.getElementById(styleId);
      if (styleNode) {
        styleNode.remove();
      }
    };
  };

export const createConfirmarCerrarPantallaEffect =
  ({
    history,
    opcionesPantalla,
    attributeName = CONFIRMAR_CERRAR_PANTALLA_ATTR,
    messageAttributeName = CONFIRMAR_CERRAR_PANTALLA_MENSAJE_ATTR,
    message = "Hay cambios o acciones pendientes. ¿Seguro que querés cerrar esta pantalla?",
  }) =>
  () => {
    const shouldConfirmClose = () =>
      opcionesPantalla.current?.[attributeName] === "s";
    const getMessage = () =>
      opcionesPantalla.current?.[messageAttributeName] || message;

    const unblock = history.block(() => {
      if (consumirSalidaSinConfirmacion()) {
        return undefined;
      }

      if (!shouldConfirmClose()) {
        return undefined;
      }

      const confirmed = window.confirm(getMessage());

      if (!confirmed) {
        marcarCancelacionNavegacionPantalla();
      }

      return confirmed;
    });

    const handleBeforeUnload = (event) => {
      if (!shouldConfirmClose()) {
        return undefined;
      }

      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      unblock();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  };
